export enum FormElementSize {
  COL_4 = 4,
  COL_3 = 3,
  COL_2 = 2,
  COL_1 = 1
}
